<template>
    <div class="addMember">
      <el-form ref="form" label-width="80px">
        <el-form-item label="姓名">
          <el-input v-model="memberInfoCopy.trueName"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="memberInfoCopy.phone" type="number"></el-input>
        </el-form-item>
        <el-form-item label="所在省">
          <el-cascader
              :options="province"
              v-model="memberInfoCopy.city"
              filterable
              :props="{value:'label'}"
              placeholder="所在省">
          </el-cascader>
        </el-form-item>
        <el-form-item label="所属公司">
          <el-input v-model="memberInfoCopy.showCompany"></el-input>
        </el-form-item>
        <el-form-item label="工厂">
          <el-input v-model="memberInfoCopy.company" disabled></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addMemberFn">确定</el-button>
          <el-button @click="cancle">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
</template>

<script>
import {addOperator,editOperator} from '@/api/api'
import bus from '@/bus'
import {testNull,testLength,testNumber} from '@/api/common'
import {regionData} from 'element-china-area-data'
import {province} from '@/assets/province'
export default {
  props:{
    memberInfo:{
      type:Object,
      required:false
    },
    id:{
      type:String,
      required:false
    }
  },
  name: 'HelloWorld',
  data () {
    return {
      msg: 'App',
      province,
      memberInfoCopy:{
        trueName:'',
        phone:'',
        city:'',
        showCompany:'',
        company:localStorage.getItem('factoryName')
      }
    }
  },
  mounted(){
    if(this.id!=''){
      this.memberInfoCopy=this.memberInfo
    }
  },
  methods:{
    cancle(){
       bus.$emit('hidePop',false)
    },
    addMemberFn(){
      const {trueName,phone,city,showCompany,company} = this.memberInfoCopy
      let test=true
      test=testNull(this,trueName,'姓名')
      if(!test){return false}
      test=testNull(this,phone,'电话')
      if(!test){return false}
      test=testNull(this,showCompany,'所属公司')
      if(!test){return false}
      test=testNull(this,city,'城市')
      if(!test){return false}
      test=testLength(this,trueName,10,'姓名')
      if(!test){return false}
      let rule=/^1[3578]\d{9}$/
      test=rule.test(phone)
      if(!test){
        this.$message({
          message:'电话格式不正确',
          type: 'warning'
        })
        return false
        }
      let newCity=typeof(city)=='object'?city[0]:city
      let id=this.id
      if(this.id!=''){
        let data=JSON.stringify({
          id,
          trueName,
          phone,
          city:newCity,
          company,
          showCompany
        })
        editOperator(data).then(res=>{
           this.fedeback(res)
        })
      }else{
        let data=JSON.stringify({
          trueName,
          phone,
          city:newCity,
          company,
          showCompany
        })
        addOperator(data).then(res=>{
           this.fedeback(res)
        })
      }
    },
    fedeback(res){
      if(res.data.state==200){
        this.form={}
        bus.$emit('closeEditMember')
        this.$message({
           message: '操作成功',
           type: 'success'
        })
      }else{
        this.$message({
           message:'操作失败',
           type: 'warning'
        })
      }
    },
  },
  beforeRouteEnter(to,from,next) {
    var that=this
    var manager=localStorage.getItem('manager')
    if(manager=='M'){
      next()
    }else{
       alert('您没有访问权限')
       next('/login')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .addCoctor {margin-left:20px;}
  .addCoctor li {height:50px;}
  .addDoctorItem {width:290px;height:30px;line-height: 30px;float: left;}
  .addDoctorItem span {width:120px;font-size:14px;text-align:right;float: left;}
  .addDoctorItem em {font-size:12px;margin-left:10px;}
  .addDoctorItem a {color:#357af1;}
  .addDoctorItem input[type=text] {color:#555;width:150px;height:30px;margin-left:5px;padding-left:10px;border:0;border-radius:4px;border:#ddd 1px solid;float: left;}
  .addDoctorItem input[type=number] {color:#555;width:150px;height:30px;margin-left:5px;padding-left:10px;border:0;border-radius:4px;border:#ddd 1px solid;float: left;}
  .addDoctorItem textarea {color:#555;width:300px;height:80px;line-height:22px;margin-left:5px;padding-left:10px;padding-top:10px;resize:none;border:#ddd 1px solid;border-radius:4px;}
  .addDoctorItem label {margin-right:30px;}
  .addDoctorItem input[type=radio] {margin-right:5px;position: relative;top:1px;}
  .addMember {width:350px;margin-left:40px;}
</style>



// WEBPACK FOOTER //
// src/components/EditOperator.vue